import { render, staticRenderFns } from "./SalesComparisionReport.vue?vue&type=template&id=27f67bfc&"
import script from "./SalesComparisionReport.vue?vue&type=script&lang=js&"
export * from "./SalesComparisionReport.vue?vue&type=script&lang=js&"
import style0 from "./SalesComparisionReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports